import React, { useState } from 'react';
import { Descriptions, Spin, Row, Col, Checkbox, Button, message } from 'antd';
import get from 'lodash/get';
import map from 'lodash/map';
import filter from 'lodash/filter';
import last from 'lodash/last';
import includes from 'lodash/includes';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { campaignManagement } from '../../../redux/actions/campaignAction';
import { CREATE_CAMPAIGN_SUCCESS } from '../../../constants/messages';
import { CAMPAIGN } from '../../../constants/routes';

const ReviewCampaignDetails = (props) => {
  const { details, onMove, showFurtherSteps } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const criteriaDetails = filter(
    get(details, 'step4.customerDetails', []),
    (detail) =>
      includes(get(details, 'step4.selectedDetails'), get(detail, 'id'))
  );

  const getGender = (gender) => {
    switch (gender) {
      case 'M':
        return 'Male';
      case 'F':
        return 'Female';
      case 'A':
        return 'Both';
      default:
        return '--';
    }
  };
  const onCreateCampaign = (payload) => {
    setLoading(true);
    dispatch(campaignManagement('create.campaign', payload))
      .then(() => {
        setLoading(false);
        message.success(CREATE_CAMPAIGN_SUCCESS);
        history.replace(CAMPAIGN);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinish = () => {
    const payload = {
      name: get(details, 'step2.name'),
      type: get(details, 'step2.type'),
      company_id: get(details, 'step2.company_id'),
      sales_channel_id: get(details, 'step1.id'),
      valid_from: get(details, 'step2.valid_from'),
      valid_to: get(details, 'step2.valid_to'),
      age_group_from: get(details, 'step3.age.0'),
      age_group_to: get(details, 'step3.age.1'),
      gender: get(details, 'step3.gender'),
      item_per_user: get(details, 'step3.item_per_user'),
      is_active: true,
      offering_id: get(details, 'step2.offering_id'),
      touchpoint_ids: map(get(details, 'step2.touchpoint_ids'), last),
      customer_field_ids: map(get(details, 'step4.selectedDetails')),
    };
    onCreateCampaign(payload);
  };

  return (
    <Spin spinning={loading}>
      <div className="product-final-confirmation-container">
        <p className="normal-heading ">Details Required </p>
        <div className="product-description-container">
          <Descriptions bordered column={3} size="small">
            <Descriptions.Item label="Saas Channel ">
              {get(details, 'step1.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Campaign Type">
              {get(details, 'step2.type') === 'SAMPLE' ? 'Sample' : 'Retail'}
            </Descriptions.Item>
            <Descriptions.Item label="Campaign Name">
              {get(details, 'step2.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Brand">
              {get(details, 'step2.meta.company.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Offering">
              {get(details, 'step2.meta.offering.name')}
            </Descriptions.Item>
            <Descriptions.Item label="Time Period">
              {get(details, 'step2.meta.valid_from')} {` - `}
              {get(details, 'step2.meta.valid_to')}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
      {get(details, 'step3') && (
        <div className="product-final-confirmation-container mt-40">
          <p className="normal-heading ">Futher Criteria </p>
          <div className="product-description-container">
            <Descriptions bordered column={2} size="small">
              <Descriptions.Item label="Age ">{`${get(
                details,
                'step3.age.0'
              )}-${get(details, 'step3.age.1')}`}</Descriptions.Item>
              <Descriptions.Item label="Item/User">
                {get(details, 'step3.item_per_user')}
              </Descriptions.Item>
              <Descriptions.Item label="Gender">
                {getGender(get(details, 'step3.gender'))}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>
      )}
      {get(details, 'step4') && (
        <div className="product-final-confirmation-container mt-40">
          <p className="normal-heading ">Brand Criteria </p>
          <div className="product-description-container pd-10">
            <Row>
              <Col xl={12}>
                <Checkbox.Group
                  style={{ width: '100%' }}
                  value={map(criteriaDetails, 'id')}
                >
                  <Row>
                    {map(criteriaDetails, (detail) => (
                      <Col span={8} className="mt-20">
                        <Checkbox value={get(detail, 'id')}>
                          {get(detail, 'name')}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </Checkbox.Group>
              </Col>
            </Row>
          </div>
        </div>
      )}
      <Row justify="space-evenly" className="mt-60">
        <Col xl={8}>
          <Button
            className="default-primary-btn"
            type="primary"
            onClick={() => onMove(showFurtherSteps ? 3 : 1)}
            icon={<ArrowLeftOutlined />}
          >
            Back
          </Button>
        </Col>
        <Col xl={12} />
        <Col xl={4}>
          <Button
            onClick={onFinish}
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default ReviewCampaignDetails;
